import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/images/logo.jpeg';
import { apiService } from '../services/apiService';

const ForgotPassword = () => {
  const [email, setEmail]     = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null);

  const handleSubmit = async e => {
    e.preventDefault();
    try {
      setLoading(true);
      setMessage(null);
      await apiService.post('auth/forgot-password', { email });
      setMessage({ type: 'success', text: 'If that email is registered, a reset link has been sent. Check your inbox.' });
      setEmail('');
    } catch (err) {
      setMessage({ type: 'error', text: err.response?.data?.message || 'Failed to send reset email.' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card" style={{ maxWidth: 460 }}>
        <div className="auth-header">
          <img src={logo} alt="MCCT Logo" style={{ height: 72, marginBottom: '1rem', borderRadius: 8 }} />
          <h2>Forgot Password</h2>
          <p style={{ color: 'var(--text-light)', marginTop: '0.25rem' }}>
            Enter your email and we'll send you a reset link.
          </p>
        </div>

        {message && (
          <div style={{
            padding: '0.75rem 1rem', borderRadius: 6, marginBottom: '1rem',
            background: message.type === 'success' ? '#d4edda' : '#f8d7da',
            color:      message.type === 'success' ? '#155724' : '#721c24',
          }}>
            {message.text}
          </div>
        )}

        <form onSubmit={handleSubmit} className="auth-form">
          <div className="form-group">
            <label htmlFor="email">Email Address</label>
            <input
              type="email" id="email" value={email}
              onChange={e => setEmail(e.target.value)}
              placeholder="you@example.com" required
            />
          </div>
          <button type="submit" className="btn btn-primary btn-block" disabled={loading}>
            {loading ? 'Sending...' : 'Send Reset Link'}
          </button>
        </form>

        <p style={{ textAlign: 'center', marginTop: '1.25rem', fontSize: '0.9rem' }}>
          <Link to="/login" style={{ color: 'var(--primary-color)' }}>← Back to Login</Link>
        </p>
      </div>
    </div>
  );
};

export default ForgotPassword;
